module.exports = __webpack_public_path__ + "media/images/flag_de-d1594c17bc5a052d51af4551835639e3.png";